import script from "./userEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./userEditModal.vue?vue&type=script&setup=true&lang=js"

import "./userEditModal.vue?vue&type=style&index=0&id=0bc4f732&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bc4f732"]])

export default __exports__